import { render, staticRenderFns } from "./Vendorcategory.vue?vue&type=template&id=e2182eb6&"
import script from "./Vendorcategory.vue?vue&type=script&lang=js&"
export * from "./Vendorcategory.vue?vue&type=script&lang=js&"
import style0 from "./Vendorcategory.vue?vue&type=style&index=0&id=e2182eb6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports